<template>
  <v-container fluid class="b-container">
    <v-sheet class="pa-3">
      <v-row>
        <v-col cols="12" lg="6">
          <v-card color="#394263" dark flat height="100%">
            <v-card-title class="justify-center">
              <v-icon class="mr-4" large v-text="icons.mdiAccountGroup"></v-icon>

              {{ translations.activeUsers[lang] }}
              {{ last2MonthsActiveUsers }}
            </v-card-title>
            <v-card-subtitle class="text-center"
              >{{ translations.uniqueUsersTwoMonths[lang] }}
            </v-card-subtitle>
          </v-card>
        </v-col>

        <v-col cols="12" lg="6">
          <v-card color="#394263" height="100%" flat dark>
            <v-card-title class="justify-center fill-height">
              <v-icon large v-text="icons.mdiHumanHandsup"></v-icon>
              {{ translations.uniqueUsers[lang] }}
              {{ activeUsers }}
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>

      <v-toolbar flat height="270">
        <ExportLinks export-key="business-statistics" :filters="filtersData" />

        <v-spacer></v-spacer>

        <v-col cols="4">
          <!-- <v-radio-group
                        class="pt-0"
                        hide-details
                        v-model="radioFilter"
                    >
                        <v-row no-gutters>
                            <v-col
                                class="pr-6"
                                cols="auto"
                                v-for="(item, index) in filters"
                                :key="index"
                            >
                                <v-radio color="secondary" :value="item.value">
                                    <template v-slot:label>
                                        <h4 class="subtitle-2">
                                            {{ item[lang] }}
                                        </h4>
                                    </template>
                                </v-radio>
                            </v-col>
                        </v-row>
                    </v-radio-group> -->
          <b-select
            v-model="radioFilter"
            :items="filters"
            :item-text="lang"
            item-value="value"
            class="mb-4"
            :label="translations.showTransactionsMadeBy[lang]"
            rounded
          ></b-select>
          <b-select
            v-model="orderBy"
            :items="headers"
            item-text="text"
            item-value="value"
            class="mb-4"
            :label="translations.orderBy[lang]"
            rounded
          ></b-select>

          <b-select
            v-model="orderPriority"
            :items="orderPriorityOptions"
            item-text="text"
            item-value="value"
            :label="translations.orderPriority[lang]"
            rounded
          ></b-select>
        </v-col>

        <v-spacer></v-spacer>

        <v-col cols="12" sm="4" md="4">
          <b-select
            v-if="companyRegions.length > 0"
            :items="companyRegions"
            item-text="name"
            item-value="store_company_network_region_id"
            :label="translations.region[lang]"
            class="mb-4"
            v-model="filtersData.region"
            rounded
          ></b-select>

          <b-search-field v-model="search"></b-search-field>
          <v-row>
            <v-col cols="6">
              <v-menu :close-on-content-click="false" offset-y max-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :label="translations.startDate[lang]"
                    color="secondary"
                    autocomplete="off"
                    hint="YYYY/DD format"
                    rounded
                    outlined
                    dense
                    clearable
                    hide-details
                    :prepend-inner-icon="icons.mdiCalendarSearch"
                    v-on="on"
                    v-model="filtersData.start_date"
                    class="mt-4"
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="filtersData.start_date"
                  color="secondary"
                  :max="maxDate"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="6">
              <v-menu :close-on-content-click="false" offset-y max-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :label="translations.endDate[lang]"
                    color="secondary"
                    autocomplete="off"
                    hint="YYYY/DD format"
                    rounded
                    outlined
                    dense
                    clearable
                    hide-details
                    :prepend-inner-icon="icons.mdiCalendarSearch"
                    v-on="on"
                    v-model="filtersData.end_date"
                    class="mt-4"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filtersData.end_date"
                  color="secondary"
                  :min="minEndDate"
                  :max="maxDate"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <!-- <v-checkbox
                        color="secondary"
                        class="mt-3 pt-0"
                        hide-details
                        v-model="filtersData.is_company"
                    >
                        <template v-slot:label>
                            <h4 class="subtitle-2">
                                {{ translations.isCompany[lang] }}
                            </h4>
                        </template>
                    </v-checkbox> -->
        </v-col>
      </v-toolbar>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="businessStatistics"
        :footer-props="{
          itemsPerPageOptions: [13],
          showCurrentPage: true,
          pageText: `${page * 12 - 11}-${
            page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
          } ${translations.paginationText[lang]} ${serverItemsLength}`,
        }"
        :page.sync="page"
        :server-items-length="serverItemsLength"
        class="b-outlined"
        :options.sync="options"
      >
        <!-- <template v-slot:item.total_points="{ item }">
                    {{ !item.is_company ? item.total_points : "" }}
                </template>

                <template v-slot:item.total_amount="{ item }">
                    {{ !item.is_company ? item.total_amount : "" }}
                </template>

                <template v-slot:item.total_transactions="{ item }">
                    {{ !item.is_company ? item.total_transactions : "" }}
                </template>

                <template v-slot:item.distinct_users="{ item }">
                    {{ !item.is_company ? item.total_users : "" }}
                </template> -->
      </v-data-table>
    </v-sheet>
  </v-container>
</template>

<script>
import {
  mdiCalendarSearch,
  mdiAccountGroup,
  mdiHumanHandsup,
  mdiFormatListCheckbox,
} from '@mdi/js';
import { mapState, mapMutations, mapActions } from 'vuex';
import translations from '@/utils/translations/loyaltyPanel/businessStatistics';
import moment from 'moment';
import debounce from 'lodash/debounce';
import ExportLinks from '@/components/general/ExportLinks.vue';

export default {
  name: 'BusinessStatistics',

  mixins: [translations],

  components: { ExportLinks },

  data() {
    return {
      icons: {
        mdiCalendarSearch,
        mdiAccountGroup,
        mdiHumanHandsup,
        mdiFormatListCheckbox,
      },
      showFilters: false,
      range: [],
      search: '',
      filters: [
        {
          el: 'Προβολή Συναλλαγών όλων των χρηστών',
          en: 'Show Transactions made by all users',
          it: 'Visualizza le transazioni di tutti gli utenti',
          value: 1,
        },
        {
          el: 'Προβολή Συναλλαγών των offline χρηστών',
          en: 'Show Transactions made by offline users',
          it: 'Visualizza le transazioni degli utenti offline',
          value: 2,
        },
        {
          el: 'Προβολή Συναλλαγών των online χρηστών',
          en: 'Show Transactions made by online users',
          it: 'Visualizzare le transazioni degli utenti online',
          value: 3,
        },
        {
          el: 'Προβολή Συναλλαγών των online και offline χρηστών',
          en: 'Show Transactions made by online and offline users',
          it: 'Visualizza le transazioni degli utenti online e offline',
          value: 4,
        },
      ],
      filtersData: {
        q: null,
        type: 'all',
        end_date: null,
        region: null,
        order: null,
        is_company: false,
      },
      radioFilter: 1,
      orderPriority: '',
      orderBy: '',
      orderPriorityOptions: [
        {
          text: 'DESC',
          value: 'desc',
        },
        {
          text: 'ASC',
          value: 'asc',
        },
      ],
      options: {},
      page: +this.$route.query.page,
      last2MonthsActiveUsers: 0,
      activeUsers: 0,
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'serverItemsLength']),
    ...mapState('loyaltyPanel/businessStatistics', ['businessStatistics', 'companyRegions']),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    minEndDate() {
      return this.filtersData && this.filtersData.start_date
        ? moment(this.filtersData.start_date).format('YYYY-MM-DD')
        : false;
    },
    maxDate() {
      return moment().subtract(1, 'd').format('YYYY-MM-DD');
    },
    // maxStartDate() {
    //     return moment().subtract(1, "d").format("YYYY-MM-DD");
    // },
    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },

    headers() {
      return [
        {
          text: this.translations.code[this.lang],
          value: 'store_code',
          cellClass: 'font-weight-bold',
        },
        {
          text: this.translations.name[this.lang],
          value: 'store_name',
          cellClass: 'font-weight-bold',
        },
        {
          text: this.translations.totalAmount[this.lang],
          value: 'total_amount',
        },
        {
          text: this.translations.transactions[this.lang],
          value: 'total_transactions',
        },
        {
          text: this.translations[`total_${this.storeMode}`][this.lang],
          value: 'total_points',
        },
        {
          text: this.translations.users[this.lang],
          value: 'total_users',
        },
        {
          text: this.translations.activeTotalUsers[this.lang],
          value: 'active_total_users',
        },
        {
          text: this.translations.totalLoyaltyCardsActivated[this.lang],
          value: 'total_loyalty_cards_activated',
        },
        {
          text: this.translations.region[this.lang],
          value: 'region_name',
        },
      ];
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/businessStatistics', [
      'getBusinessStatistics',
      'getCompanyRegions',
    ]),

    handleSearch() {
      // let sendingData = {
      //     query: this.query,
      //     filters: {
      //         ...this.filtersData,
      //         q: this.search,
      //     },
      // };
      // this.getBusinessStatistics(sendingData);
      this.filtersData.q = this.search;
    },

    getFilteredData() {
      let sendingData = {
        query: this.query,
        filters: this.filtersData,
      };
      this.getBusinessStatistics(sendingData);
    },
  },
  async mounted() {
    this.getCompanyRegions();
    this.filtersData.end_date = moment().subtract(1, 'd').format('YYYY-MM-DD');
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },
  watch: {
    options: {
      handler(val) {
        if (val.sortBy[0]) {
          this.filtersData.order = val.sortBy[0].split('[')[0];

          if (val.sortDesc) {
            this.filtersData.order += ',' + (val.sortDesc[0] ? 'desc' : 'asc');
          }
          this.getFilteredData();
        }
      },
      deep: true,
    },
    businessStatistics: {
      handler(val) {
        this.activeUsers =
          (val.find((x) => x.is_region) || val.find((x) => x.is_company) || {}).total_users || '0';
        this.last2MonthsActiveUsers =
          (val.find((x) => x.is_region) || val.find((x) => x.is_company) || {})
            .active_total_users || '0';
        // this.activeUsers = val[val.length - 1].total_users
        //     ? val[val.length - 1].total_users
        //     : "0";
        // this.last2MonthsActiveUsers = val[val.length - 1].active_total_users
        //     ? val[val.length - 1].active_total_users
        //     : "0";
      },
      deep: true,
    },
    radioFilter(val) {
      switch (val) {
        case 1:
          this.filtersData.type = 'all';
          break;
        case 2:
          this.filtersData.type = 'offline';
          break;
        case 3:
          this.filtersData.type = 'online';
          break;
        case 4:
          this.filtersData.type = 'both';
          break;
      }
      this.page = 1;
    },

    orderBy(val) {
      if (this.orderPriority) {
        this.filtersData.order = val + ',' + this.orderPriority;
      } else {
        this.orderPriority = 'desc';
      }

      this.page = 1;
    },

    orderPriority(val) {
      if (this.orderBy) {
        this.filtersData.order = this.orderBy + ',' + val;
        this.page = 1;
      }
    },

    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.getFilteredData();
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

    search(val) {
      // if (val == null) {
      //     let sendingData = {
      //         query: this.query,
      //         filters: this.filtersData,
      //     };
      //     this.getBusinessStatistics(sendingData);
      // } else {
      //     this.debouncedSearch();
      // }
      this.debouncedSearch();
    },

    filtersData: {
      deep: true,
      handler(val) {
        if (val) {
          this.getFilteredData();
        }
      },
    },
  },
};
</script>
